import { useAuthentication } from "../AuthenticationProvider";
import Link from "next/link";
import HelpIcon from "./help-icon.svg";

export const Header = () => {
  const { signOut } = useAuthentication();

  return (
    <header className="c-header is-flex is-align-items-center is-justify-content-space-between px-5 u-print-hidden">
      <div className="u-line-height-1 u-flex-center">
        <Link href="/sections" className="u-flex-center">
          <img
            src="/assets/images/logo_horizontal.svg"
            className="c-header__logo"
            alt="Studyplus for School"
            width={218}
            height={24}
          />
        </Link>
        <div className="c-header__feature-title has-background-primary has-text-white has-text-weight-bold is-size-5 px-5 py-2 ml-4">
          入退室受付画面
        </div>
      </div>
      <nav className="is-flex is-align-items-center is-justify-content-center">
        <button
          type="button"
          className="c-button--ghost has-text-primary"
          onClick={signOut}
        >
          ログアウト
        </button>
        <a
          href="https://fs-help.studyplus.co.jp/ja/articles/3079966"
          target="_blank"
          rel="noopener noreferrer"
          className="c-help-link"
        >
          <HelpIcon />
        </a>
      </nav>
    </header>
  );
};
